// Remote on/off switches for features, read from the Firestore
// settings/settings doc at startup (readSettingsCallback) — admin-only
// writes (Firestore rules), editable in the Firebase console. A missing or
// non-true field means OFF, so a feature stays hidden until explicitly
// enabled, with no app release needed to turn it on later.
//
// photo_book_enabled_v2: Print Photo Book menu entries. Hidden since 4.7.55
// (2026-10-09) — Peecho's hosted checkout showed an empty cart in iPhone
// Safari (€0.00, no product): it needs iOS/Safari 16.4+, so 4.9.55 added a
// message for older iPhones (2026-10-18). A new switch name (2026-10-24) so
// that turning it on doesn't also show the book in 4.7.55–4.8.55, which read
// the old `photo_book_enabled` (leave that one off) and lack that message.
let flags = { photoBook: false, demoWanderlistUid: null };

export function setFeatureFlags(settings) {
  flags = {
    photoBook: settings?.photo_book_enabled_v2 === true,
    demoWanderlistUid: typeof settings?.demo_wanderlist_uid === "string" ? settings.demo_wanderlist_uid : null,
  };
}

// demo_wanderlist_uid (2026-10-25): a guest's Wanderlist shows this account's
// guides (read-only; guide_info is public) as a sample, so it isn't empty.
// Default: the TestUser3 demo account; set the field to change it.
const DEFAULT_DEMO_WANDERLIST_UID = "UOwTQnrXQHOdLFPoT10bBNQNurD3";
export const demoWanderlistUid = () => flags.demoWanderlistUid || DEFAULT_DEMO_WANDERLIST_UID;

// Development builds always show it (2026-10-17), so it can be tested —
// e.g. a real order — without switching it on for every user.
const DEV_BUILD = process.env.NODE_ENV === "development";

export const isPhotoBookEnabled = () => DEV_BUILD || flags.photoBook;
